<div class="mat-elevation-z5">
    <template [ngTemplateOutlet]="template"></template>
</div>
